const FILENAME = /^[^/\\]+\.[a-z0-9]{2,5}$/i;
const PERCENT_ENCODED = /%[0-9A-Fa-f]{2}/;

/**
 * Some stored titles arrive percent-encoded from the source URL, so an operator
 * reads "Informativo%20GETRI" in the daily queue. Decode only those: a title
 * without an escape sequence is never rewritten.
 */
export function decodeStoredTitle(title: string): string {
  if (!PERCENT_ENCODED.test(title)) return title;
  try {
    return decodeURIComponent(title).replace(/\s+/g, " ").trim();
  } catch {
    return title;
  }
}

/**
 * Operator-facing title for stored evidence. Filename fallbacks from the
 * extractor stay honest: LCP 214 is read from the URL/name, never invented.
 */
export function evidenceDisplayTitle(title: string, canonicalUrl = ""): string {
  const raw = decodeStoredTitle(title.trim());
  const haystack = `${canonicalUrl} ${raw}`;
  const complementary = /\blcp[_-]?(\d+)\b/i.exec(haystack);
  if (complementary) return `LCP ${complementary[1]}`;
  if (FILENAME.test(raw)) {
    return (
      raw
        .replace(/\.[a-z0-9]{2,5}$/i, "")
        .replace(/[_-]+/g, " ")
        .trim() || raw
    );
  }
  return raw;
}
